export { BarComponent } from './bar.component';
export { ProgressbarComponent } from './progressbar.component';
export { ProgressbarModule } from './progressbar.module';
export { ProgressbarConfig } from './progressbar.config';



// WEBPACK FOOTER //
// ./.tmp/progressbar/index.ts